import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'Conversation'; // Adjust the URL based on your actual API's URL

const createConversation = async (description, menuType, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/start`, {description,menuType} , {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error creating conversation:', error);
        throw error;
    }
};

const sendMessage = async (conversationId, userMessage, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/${conversationId}/chat/v2`, userMessage, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error sending message:', error);
        throw error;
    }
};

const getConversationHistory = async (conversationId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${conversationId}/history`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error retrieving conversation history:', error);
        throw error;
    }
};

const deleteConversation = async (conversationId, token) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${conversationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error retrieving conversation history:', error);
        throw error;
    }
};

const renameConversation = async (conversationId, description, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${conversationId}`, description , {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error creating conversation:', error);
        throw error;
    }
};

const getUserConversations = async (menuType, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            params: {
                menuType
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error retrieving conversation history:', error);
        throw error;
    }
};

const uploadFile = async (conversationId, file, token) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await axios.post(`${API_BASE_URL}/${conversationId}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};

export const ChatService = {
    createConversation,
    sendMessage,
    getConversationHistory,
    getUserConversations,
    uploadFile,
    deleteConversation,
    renameConversation
};
